// @flow

import * as React from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import useLoopingIncrementor from "../hooks/useLoopingIncrementor";
import useInterval from "../hooks/useInterval";
import useHover from "../hooks/useHover";

type PropsType = {
    images: string[],
};

const HelloAnimation = (props: PropsType): React.Node => {
    const imagePath = `${window.drupalAssetsDir}/images/languages`;
    const [hoverRef, isHovered] = useHover();
    const { currentIndex, increment } = useLoopingIncrementor(
        props.images.length
    );

    useInterval(() => {
        increment(isHovered);
    }, 2500);

    return (
        <div className="hello-animation" ref={hoverRef}>
            <TransitionGroup component={React.Fragment}>
                <CSSTransition
                    key={props.images[currentIndex]}
                    timeout={700}
                    classNames="fade-in-up"
                >
                    <img
                        src={`${imagePath}/${props.images[currentIndex]}`}
                        alt="Hello"
                    />
                </CSSTransition>
            </TransitionGroup>
        </div>
    );
};

export default HelloAnimation;
